[
  {
    "id": "pates",
    "name": "Pâtes",
    "aliases": ["coquillettes", "penne", "fusilli"],
    "category_key": "epicerie-salee",
    "unit_label": "paquet",
    "pack_size": 1,
    "contents_qty": 500,
    "contents_unit": "g",
    "rate_qty": 1,
    "rate_per_days": 7
  },
  {
    "id": "spaghetti",
    "name": "Spaghetti",
    "aliases": ["spaghettis"],
    "category_key": "epicerie-salee",
    "unit_label": "paquet",
    "pack_size": 1,
    "contents_qty": 500,
    "contents_unit": "g",
    "rate_qty": 1,
    "rate_per_days": 14
  },
  {
    "id": "nouilles",
    "name": "Nouilles chinoises",
    "aliases": ["nouilles"],
    "category_key": "epicerie-salee",
    "unit_label": "paquet",
    "pack_size": 1,
    "rate_qty": 1,
    "rate_per_days": 30
  },
  {
    "id": "riz",
    "name": "Riz",
    "aliases": ["riz basmati"],
    "category_key": "epicerie-salee",
    "unit_label": "paquet",
    "pack_size": 1,
    "contents_qty": 1,
    "contents_unit": "kg",
    "rate_qty": 1,
    "rate_per_days": 21
  },
  {
    "id": "semoule",
    "name": "Semoule",
    "aliases": ["couscous"],
    "category_key": "epicerie-salee",
    "unit_label": "paquet",
    "pack_size": 1,
    "contents_qty": 500,
    "contents_unit": "g",
    "rate_qty": 1,
    "rate_per_days": 45
  },
  {
    "id": "quinoa",
    "name": "Quinoa",
    "category_key": "epicerie-salee",
    "unit_label": "paquet",
    "pack_size": 1,
    "contents_qty": 500,
    "contents_unit": "g",
    "rate_qty": 1,
    "rate_per_days": 60
  },
  {
    "id": "lentilles",
    "name": "Lentilles",
    "category_key": "epicerie-salee",
    "unit_label": "paquet",
    "pack_size": 1,
    "contents_qty": 500,
    "contents_unit": "g",
    "rate_qty": 1,
    "rate_per_days": 45
  },
  {
    "id": "pois-chiches",
    "name": "Pois chiches",
    "category_key": "epicerie-salee",
    "unit_label": "boîte",
    "pack_size": 1,
    "contents_qty": 400,
    "contents_unit": "g",
    "rate_qty": 1,
    "rate_per_days": 30
  },
  {
    "id": "haricots-rouges",
    "name": "Haricots rouges",
    "category_key": "epicerie-salee",
    "unit_label": "boîte",
    "pack_size": 1,
    "contents_qty": 400,
    "contents_unit": "g",
    "rate_qty": 1,
    "rate_per_days": 45
  },
  {
    "id": "mais",
    "name": "Maïs",
    "category_key": "epicerie-salee",
    "unit_label": "boîte",
    "pack_size": 1,
    "contents_qty": 300,
    "contents_unit": "g",
    "rate_qty": 1,
    "rate_per_days": 21
  },
  {
    "id": "petits-pois",
    "name": "Petits pois",
    "aliases": ["petits pois carottes"],
    "category_key": "epicerie-salee",
    "unit_label": "boîte",
    "pack_size": 1,
    "contents_qty": 400,
    "contents_unit": "g",
    "rate_qty": 1,
    "rate_per_days": 30
  },
  {
    "id": "tomates-pelees",
    "name": "Tomates pelées",
    "aliases": ["tomates concassees"],
    "category_key": "epicerie-salee",
    "unit_label": "boîte",
    "pack_size": 1,
    "contents_qty": 400,
    "contents_unit": "g",
    "rate_qty": 1,
    "rate_per_days": 21
  },
  {
    "id": "coulis-de-tomate",
    "name": "Coulis de tomate",
    "aliases": ["passata"],
    "category_key": "epicerie-salee",
    "unit_label": "bouteille",
    "pack_size": 1,
    "contents_qty": 500,
    "contents_unit": "g",
    "rate_qty": 1,
    "rate_per_days": 14
  },
  {
    "id": "concentre-de-tomate",
    "name": "Concentré de tomate",
    "category_key": "epicerie-salee",
    "unit_label": "boîte",
    "pack_size": 1,
    "contents_qty": 140,
    "contents_unit": "g",
    "rate_qty": 1,
    "rate_per_days": 45
  },
  {
    "id": "sauce-tomate",
    "name": "Sauce tomate",
    "aliases": ["sauce bolognaise"],
    "category_key": "epicerie-salee",
    "unit_label": "pot",
    "pack_size": 1,
    "contents_qty": 400,
    "contents_unit": "g",
    "rate_qty": 1,
    "rate_per_days": 10
  },
  {
    "id": "pesto",
    "name": "Pesto",
    "category_key": "epicerie-salee",
    "unit_label": "pot",
    "pack_size": 1,
    "contents_qty": 190,
    "contents_unit": "g",
    "rate_qty": 1,
    "rate_per_days": 30
  },
  {
    "id": "thon",
    "name": "Thon en boîte",
    "aliases": ["thon"],
    "category_key": "epicerie-salee",
    "unit_label": "boîte",
    "pack_size": 3,
    "contents_qty": 140,
    "contents_unit": "g",
    "rate_qty": 1,
    "rate_per_days": 7
  },
  {
    "id": "sardines",
    "name": "Sardines",
    "category_key": "epicerie-salee",
    "unit_label": "boîte",
    "pack_size": 1,
    "rate_qty": 1,
    "rate_per_days": 21
  },
  {
    "id": "farine",
    "name": "Farine",
    "category_key": "epicerie-salee",
    "unit_label": "paquet",
    "pack_size": 1,
    "contents_qty": 1,
    "contents_unit": "kg",
    "rate_qty": 1,
    "rate_per_days": 45
  },
  {
    "id": "sel",
    "name": "Sel",
    "category_key": "epicerie-salee",
    "unit_label": "paquet",
    "pack_size": 1,
    "contents_qty": 1,
    "contents_unit": "kg",
    "rate_qty": 1,
    "rate_per_days": 180
  },
  {
    "id": "poivre",
    "name": "Poivre",
    "category_key": "epicerie-salee",
    "unit_label": "pot",
    "pack_size": 1,
    "rate_qty": 1,
    "rate_per_days": 120
  },
  {
    "id": "herbes-de-provence",
    "name": "Herbes de Provence",
    "category_key": "epicerie-salee",
    "unit_label": "pot",
    "pack_size": 1,
    "rate_qty": 1,
    "rate_per_days": 120
  },
  {
    "id": "epices",
    "name": "Épices",
    "aliases": ["curry", "paprika", "cumin"],
    "category_key": "epicerie-salee",
    "unit_label": "pot",
    "pack_size": 1
  },
  {
    "id": "bouillon",
    "name": "Bouillon cube",
    "aliases": ["bouillon", "cube"],
    "category_key": "epicerie-salee",
    "unit_label": "boîte",
    "pack_size": 1,
    "rate_qty": 1,
    "rate_per_days": 45
  },
  {
    "id": "huile-olive",
    "name": "Huile d'olive",
    "aliases": ["huile"],
    "category_key": "epicerie-salee",
    "unit_label": "bouteille",
    "pack_size": 1,
    "contents_qty": 1,
    "contents_unit": "l",
    "rate_qty": 1,
    "rate_per_days": 30
  },
  {
    "id": "huile-tournesol",
    "name": "Huile de tournesol",
    "category_key": "epicerie-salee",
    "unit_label": "bouteille",
    "pack_size": 1,
    "contents_qty": 1,
    "contents_unit": "l",
    "rate_qty": 1,
    "rate_per_days": 60
  },
  {
    "id": "vinaigre",
    "name": "Vinaigre",
    "aliases": ["vinaigre balsamique", "vinaigre de vin"],
    "category_key": "epicerie-salee",
    "unit_label": "bouteille",
    "pack_size": 1,
    "contents_qty": 50,
    "contents_unit": "cl",
    "rate_qty": 1,
    "rate_per_days": 90
  },
  {
    "id": "moutarde",
    "name": "Moutarde",
    "category_key": "epicerie-salee",
    "unit_label": "pot",
    "pack_size": 1,
    "contents_qty": 200,
    "contents_unit": "g",
    "rate_qty": 1,
    "rate_per_days": 45
  },
  {
    "id": "mayonnaise",
    "name": "Mayonnaise",
    "aliases": ["mayo"],
    "category_key": "epicerie-salee",
    "unit_label": "pot",
    "pack_size": 1,
    "rate_qty": 1,
    "rate_per_days": 45
  },
  {
    "id": "ketchup",
    "name": "Ketchup",
    "category_key": "epicerie-salee",
    "unit_label": "bouteille",
    "pack_size": 1,
    "rate_qty": 1,
    "rate_per_days": 45
  },
  {
    "id": "sauce-soja",
    "name": "Sauce soja",
    "category_key": "epicerie-salee",
    "unit_label": "bouteille",
    "pack_size": 1,
    "rate_qty": 1,
    "rate_per_days": 90
  },
  {
    "id": "cornichons",
    "name": "Cornichons",
    "category_key": "epicerie-salee",
    "unit_label": "bocal",
    "pack_size": 1,
    "rate_qty": 1,
    "rate_per_days": 45
  },
  {
    "id": "olives",
    "name": "Olives",
    "category_key": "epicerie-salee",
    "unit_label": "bocal",
    "pack_size": 1,
    "rate_qty": 1,
    "rate_per_days": 21
  },
  {
    "id": "soupe",
    "name": "Soupe",
    "aliases": ["veloute"],
    "category_key": "epicerie-salee",
    "unit_label": "brique",
    "pack_size": 1,
    "contents_qty": 1,
    "contents_unit": "l",
    "rate_qty": 1,
    "rate_per_days": 14
  },
  {
    "id": "puree-flocons",
    "name": "Purée en flocons",
    "aliases": ["puree"],
    "category_key": "epicerie-salee",
    "unit_label": "paquet",
    "pack_size": 1,
    "rate_qty": 1,
    "rate_per_days": 45
  },
  {
    "id": "chips",
    "name": "Chips",
    "category_key": "epicerie-salee",
    "unit_label": "paquet",
    "pack_size": 1,
    "rate_qty": 1,
    "rate_per_days": 7
  },
  {
    "id": "biscuits-aperitif",
    "name": "Biscuits apéritif",
    "aliases": ["crackers", "biscuits sales"],
    "category_key": "epicerie-salee",
    "unit_label": "paquet",
    "pack_size": 1,
    "rate_qty": 1,
    "rate_per_days": 14
  },
  {
    "id": "cacahuetes",
    "name": "Cacahuètes",
    "aliases": ["arachides"],
    "category_key": "epicerie-salee",
    "unit_label": "sachet",
    "pack_size": 1,
    "rate_qty": 1,
    "rate_per_days": 21
  },
  {
    "id": "lait-de-coco",
    "name": "Lait de coco",
    "category_key": "epicerie-salee",
    "unit_label": "boîte",
    "pack_size": 1,
    "contents_qty": 40,
    "contents_unit": "cl",
    "rate_qty": 1,
    "rate_per_days": 45
  }
]
